import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import IconButton from 'components/IconButton';
import Theme from 'styles/theme';

import { ICON_ALIGNMENT } from './constants';

const PillButton = ({
  className,
  ariaLabel,
  children,
  iconAlignment,
  isInverted,
  text,
  ...otherProps
}) => {
  const alignmentClass = classNames('PillButton__inner', className, {
    'PillButton__inner--left': iconAlignment === ICON_ALIGNMENT.LEFT,
    'PillButton__inner--right': iconAlignment === ICON_ALIGNMENT.RIGHT,
    'PillButton__inner--inverted': isInverted,
  });

  return (
    <IconButton aria-label={ariaLabel} {...otherProps}>
      <span className={alignmentClass}>
        <span className="PillButton__icon">{children}</span>
        <span className="PillButton__text">{text}</span>
      </span>
      <style jsx>{`
        .PillButton__inner {
          display: flex;
          align-items: center;
          max-width: 100%;
          padding: ${Theme.get('spacing') * 1.25}px ${Theme.get('spacing') * 2}px;
          border: 1px solid ${Theme.get('colors-black-20')};
          border-radius: ${Theme.get('border-radius-capsule-px')};
          outline: 0;
          background-color: transparent;
          cursor: pointer;
          appearance: none;
          transition: border-color ${Theme.get('transition-duration-ms')};
          max-height: 32px;
        }

        .PillButton__inner--right {
          flex-direction: row-reverse;
        }

        .PillButton__inner--right .PillButton__icon {
          margin-left: ${Theme.get('spacing')}px;
          margin-right: 0;
        }

        .PillButton__icon {
          margin-right: ${Theme.get('spacing')}px;
          margin-left: 0;
          display: flex;
          align-items: center;
        }

        .PillButton__text {
          font-size: ${Theme.get('font-size-small-px')};
          font-weight: ${Theme.get('font-weight-semi-bold')};
          display: inline-block;
          color: ${Theme.get('colors-black')};
          text-transform: uppercase;
          letter-spacing: ${Theme.get('letter-spacing-extra-large-px')};
        }

        .PillButton__inner--inverted {
          border-color: ${Theme.get('colors-black-60')};
        }

        .PillButton__inner--inverted .PillButton__text {
          color: ${Theme.get('colors-white')};
        }

        .PillButton__inner:hover,
        .PillButton__inner.focused {
          border-color: ${Theme.get('colors-black-80')};
        }
        .PillButton .IconButton {
          position: relative;
          width: 100%;
          height: 100%;
          outline-offset: -2px;
          background-color: rgba(0, 0, 0, 0);
          transition: background-color ${Theme.get('transition-duration-ms')}
            ${Theme.get('transition-timing-ease-out')};
        }
      `}</style>
    </IconButton>
  );
};

PillButton.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  iconAlignment: PropTypes.string,
  isInverted: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

PillButton.defaultProps = {
  className: '',
  iconAlignment: 'right',
  isInverted: false,
};

export default PillButton;
